import ServiceFactory from "../service-factory";
import ShareSpaceRecipientRecord from "models/view-models/share-spaces/share-space-recipient-record";

export interface ShareSpaceRecipientResourcePathParams {
    id?: number;
}

const baseEndpoint = "sharespacesrecipients";
const resourceType = ShareSpaceRecipientRecord;

const ShareSpaceRecipientService = {
    bulkCreate: ServiceFactory.bulkCreate<ShareSpaceRecipientRecord>(
        resourceType,
        baseEndpoint
    ),
};

export default ShareSpaceRecipientService;
